export default __webpack_public_path__ + "static/heartHands-7138f4d116d33b59156056e50248ccbb.svg";